module.exports = __webpack_public_path__ + "assets/img/block-right-hover-a9cd23a3.png";